import React, { FC, useEffect } from 'react'
import AOS from 'aos'
import BannerSec2 from 'components/Common/BannerSec2'
import FaqSection from 'components/ServicePage/FaqSection'
import ContactUsSection from 'components/ServicePage/ContactUsSection'
import ContactInformation from 'components/HomePage/ContactInformation'
// import { CDN_URL } from 'config/site'
import BlogListSection, { BlogListSectionProps } from './BlogListSection'

const BlogListingPage: FC<BlogListSectionProps> = (props) => {
  useEffect(() => {
    AOS.init()
  }, [])

  return (
    <div>
      <BannerSec2
        bannerimg="/assets/images/blog-banner-img.svg"
        blueTitle=""
        title="Our Recent"
        blueTitle2="Blogs"
        subTitle="WebClues builds Experiences and Opportunities for Businesses Desiring Success and Growth."
        btnText1="Get In"
        btnText2="Touch"
        btnLink="/get-quote"
        altTag="Our Recent Blogs"
      />
      {/* <FirstSection /> */}
      {/* <SubscribeSection /> */}
      <BlogListSection {...props} />

      <FaqSection
        data={{
          title: 'FAQs',
          subTitle: '',
        }}
      />
      <ContactUsSection
        data={{
          title: 'Hi! Ping Us',
          subTitle: 'Contacting us is the first step towards success.',
        }}
      />
      <ContactInformation
        data={{
          title: 'Regional Contact Info',
          subTitle: 'We can give you the Wings to Fly. Contact us now!',
        }}
      />
    </div>
  )
}

export default BlogListingPage
